// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/common.css'
import VueClipboard from 'vue-clipboard2'
// 引入
import VueLazyload from 'vue-lazyload'
// 配置
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 2,
  error: require('../static/img/logo.png'),
  loading: require('../static/img/logo.png') // 注意路径使用require（我这里使用相对路径）
})
Vue.prototype.$axios = axios
Vue.config.productionTip = false;
Vue.use(ElementUI)
Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js